module.exports = __webpack_public_path__ + "static/media/npci_logo.e17f4964.png";